import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import NoData from '../../../../components/NoData';
import { ShimmerComponent } from '../../../../components/Shimmer/ShimmerComponent';
import BouncingLogo from '../../../../components/Shimmer/BouncingLogo';

export const getToggleButtonBackground = (buttonViewType, currentViewType, isLoading) => {
  if (currentViewType === buttonViewType) return 'black';
  if (isLoading) return '#e4e4e7';
  return '#fafafa';
};

export const getToggleButtonColor = (buttonViewType, currentViewType, isLoading) => {
  if (currentViewType === buttonViewType) return 'white';
  if (isLoading) return '#a9a9ab';
  return 'black';
};

export const getToggleButtonStyle = (buttonViewType, currentViewType, isLoading) => ({
  background: getToggleButtonBackground(buttonViewType, currentViewType, isLoading),
  color: getToggleButtonColor(buttonViewType, currentViewType, isLoading),
  borderColor: isLoading ? '#a9a9ab' : 'black',
  textTransform: 'capitalize',
  height: '40px',
});

export const renderErrorState = ({ showNoChannelSelected = false }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '400px',
    }}
  >
    <NoData textValue={showNoChannelSelected ? 'No channel selected' : 'Error loading data'} />
  </Box>
);

export const renderLoadingState = () => (
  <ShimmerComponent
    updatedStyle={{
      width: '100%',
      height: '70%',
      backgroundSize: '2000px 800px',
      border: '0px',
    }}
  >
    <BouncingLogo height="48vh" text="Loading..." />
  </ShimmerComponent>
);

export const renderNoDataState = () => <NoData />;

// PropTypes for utility functions
getToggleButtonBackground.propTypes = {
  buttonViewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currentViewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

getToggleButtonColor.propTypes = {
  buttonViewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currentViewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

getToggleButtonStyle.propTypes = {
  buttonViewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currentViewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isLoading: PropTypes.bool.isRequired,
};
